<template>
  <div class="panel">
    <touch class="ranking" @tap="gotoRanking"></touch>
    <touch class="map" @tap="gotoOverview">
      <span class="icon"></span>
      <h4>爱心<br/>地图</h4>
    </touch>
    <div class="dial-plate">
      <div class="progress">
        <circle-progress
          class="plate"
          :progress="total"
          :radius="210"
          :strokeWidth="4"
        />

        <div class="progress-bar">
          <circle-progress
            class="total"
            :progress="total"
            :radius="165"
            :strokeWidth="20"
          />
          <circle-progress
            v-show="remainingDuration > 0"
            class="current"
            :progress="current"
            :radius="165"
            :strokeWidth="30"
          ></circle-progress>
        </div>
      </div>
      <div class="time">
        <div class="overage">{{ remainingDuration }}</div>
        <p>剩余可捐赠时长</p>
      </div>
    </div>
    <touch class="donate-btn" :class="{ active: canDonate }" @tap="donate">{{ donateText }}</touch>
    <p class="tip">{{ donateTip }}</p>
    <div v-show="showModal" class="modal">
      <touch class="mask"></touch>
      <transition name="slide-up">
        <div v-show="showModal" class="inner">
          <div class="content">
            <love-map :school="donationObjects" :current="donationObject" />
            <h4>捐赠成功</h4>
            <p>你刚刚成功捐赠了 {{ donateCourse }} 节课程！</p>
            <p>今日捐赠学校：<strong>{{ donationObject }}</strong></p>
          </div>
          <touch class="goto-overview" @tap="openOverview">查看我的爱心地图</touch>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import actions from '@/store/action-types'

  import CircleProgress from '@/components/CircleProgress'
  import LoveMap from '@/components/LoveMap'

  export default {
    name: 'donate-panel',
    props: {
      remainingDuration: {
        type: Number,
        default: 0
      },
      durationOfToday: {
        type: Number,
        default: 0
      }
    },
    data () {
      return {
        // 因为对象是个圆环，所以总长度就是 0.85，而非 1
        total: 0.85,
        showModal: false,
        donateCourse: 0
      }
    },
    computed: {
      ...mapGetters([
        'donationObject',
        'donationObjects'
      ]),
      basicDonateDuration () {
        return this.$store.state.BASIC_DONATE_DURATION
      },
      canDonate () {
        return false
        // return this.remainingDuration >= this.basicDonateDuration
      },
      canDonateCourse () {
        return Math.floor(this.remainingDuration / this.basicDonateDuration)
      },
      donateText () {
        /* if (this.remainingDuration >= this.basicDonateDuration) {
          return `捐赠 ${this.canDonateCourse} 节课程`
        } else {
          return '捐赠课程'
        } */
        return '捐赠课程'
      },
      donateTip () {
        /* if (this.durationOfToday > 0) {
          return `满 ${this.basicDonateDuration} 分钟即可捐赠一次，今日累计捐赠课程 ${Math.floor(this.durationOfToday / this.basicDonateDuration)} 次`
        } else {
          return `学习 ${this.basicDonateDuration} 分钟就可以捐课啦，快去学习吧！`
        } */
        return '本期活动已结束'
      },
      current () {
        if (this.remainingDuration >= this.basicDonateDuration) {
          return this.total
        } else {
          return this.remainingDuration / this.basicDonateDuration * this.total
        }
      }
    },
    methods: {
      openModal () {
        this.showModal = true
      },
      closeModal () {
        this.showModal = false
      },
      donate () {
        if (this.canDonate) {
          this.$track.sendActionTrack('csr_home', 'click_donate', {
            num: this.canDonateCourse
          })
          this.openModal()
          this.donateCourse = this.canDonateCourse
          this.$store.dispatch(actions.post.DONATE_COURSE, {
            duration: this.canDonateCourse * this.basicDonateDuration
          }).then(() => {
            this.$track.sendActionTrack('csr_home', 'pop_donate_succeed')
          })
        }
      },
      gotoRanking () {
        this.$track.sendActionTrack('csr_home', 'click_rank')
        this.$router.push({name: 'ranking', params: {tab: 'person'}})
      },
      gotoOverview () {
        this.$track.sendActionTrack('csr_home', 'click_donation_map')
        this.$router.push('overview')
      },
      openOverview () {
        this.$track.sendActionTrack('csr_home', 'click_map_pop')
        this.$router.push('overview')
        this.closeModal()
      }
    },
    components: {
      CircleProgress,
      LoveMap
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  $rankingIcon: "https://cdn.llscdn.com/fe-static/lls-with-tfchina/cup-9DELTr6t.png";
  $loveIcon: "https://cdn.llscdn.com/fe-static/lls-with-tfchina/love-neDOm0nN.png";

  .panel {
    @include border-radius;
    position: relative;
    height: 700px;
    padding: 40px;
    background-color: $darkRed;
    background-image: linear-gradient(0deg, #ff7777 0%, #ff4747 100%);
    box-sizing: border-box;
    .ranking {
      width: 88px;
      height: 88px;
      background-color: $pink;
      background-image: url($rankingIcon);
      background-size: 48px 48px;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 50%;
    }
    .map {
      position: absolute;
      top: 40px;
      right: 0;
      width: 165px;
      height: 88px;
      background-color: $pink;
      border-top-left-radius: 44px;
      border-bottom-left-radius: 44px;
      .icon {
        position: relative;
        top: 8px;
        left: 8px;
        display: inline-block;
        width: 72px;
        height: 72px;
        background-color: #ff4747;
        background-image: url($loveIcon);
        background-size: 48px 48px;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50%;
      }
      h4 {
        float: right;
        margin-top: 13px;
        margin-right: 17px;
        font-size: 24px;
        color: $white;
        line-height: 32px;
      }
    }
    .dial-plate {
      position: relative;
      width: 420px;
      height: 370px;
      margin-left: auto;
      margin-right: auto;
      .progress {
        position: relative;
        top: -50px;
        width: 420px;
        height: 420px;
        transform: rotate(207deg);
        .plate {
          position: absolute;
          top: 0;
          left: 0;
          width: 420px;
          height: 420px;
          stroke: $white;
          stroke-dasharray: 4 8;
          stroke-dashoffset: 3000;
          stroke-linecap: round;
          stroke-opacity: 0.2;
          fill: none;
          animation: progress 4s linear forwards infinite;
        }
        .progress-bar {
          position: relative;
          top: 30px;
          z-index: 2;
          width: 360px;
          height: 360px;
          margin-left: auto;
          margin-right: auto;
        }
        .total {
          position: absolute;
          top: 5px;
          left: 5px;
          z-index: 3;
          width: 350px;
          height: 350px;
          stroke: $white;
          stroke-linecap: round;
          stroke-opacity: 0.2;
          fill: none;
        }
        .current {
          position: absolute;
          top: 0;
          left: 0;
          z-index: 4;
          width: 360px;
          height: 360px;
          stroke: $white;
          stroke-linecap: round;
          fill: none;
          stroke-dasharray: 1000;
          stroke-dashoffset: 1000;
          animation: progress 2s ease-in forwards;
        }
      }
      .time {
        position: absolute;
        top: 120px;
        left: 50%;
        width: 250px;
        margin-top: -1em;
        margin-left: -125px;
        .overage {
          position: relative;
          font-size: 120px;
          width: 160px;
          margin-left: 45px;
          color: $white;
          text-align: center;
          line-height: 1em;
          &::after {
            position: absolute;
            bottom: 1em;
            right: -2em;
            content: '分钟';
            font-size: 20px;
            line-height: 1em;
          }
        }
        p {
          font-size: 24px;
          color: rgba($white, 0.64);
          text-align: center;
          line-height: 35px;
        }
      }
      
    }
    .donate-btn {
      width: 602px;
      height: 76px;
      margin-top: 30px;
      font-size: 28px;
      color: rgba($white, 0.68);
      text-align: center;
      line-height: 76px;
      background-color: rgb(255, 138, 138);
      border: 4px solid rgb(255, 138, 138);
      border-radius: 42px;
      box-sizing: content-box;
      &.active {
        color: $red;
        background-color: $white;
        border-color: rgb(255, 160, 160);
      }
    }
    .tip {
      margin-top: 30px;
      font-size: 26px;
      line-height: 28px;
      color: rgba($white, 0.54);
      text-align: center;
    }
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 30;
    width: 100%;
    height: 100%;
    .mask {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background-color: rgba($black, 0.8);
    }
    .inner {
      @include position-center;
      z-index: 2;
      width: 640px;
      height: 755px;
      .content {
        width: 100%;
        height: 610px;
        border-radius: 24px;
        background-color: $white;
        overflow: hidden;
        .love-map {
          margin-top: -140px;
          height: 460px;
        }
        h4 {
          margin-top: 30px;
          margin-bottom: 20px;
          font-size: 36px;
          color: $darkRed;
          text-align: center;
        }
        p {
          width: 480px;
          margin-left: auto;
          margin-right: auto;
          font-size: 30px;
          color: rgba($black, 0.87);
          line-height: 42px;
          strong {
            font-weight: normal;
            color: $darkRed;
          }
        }
      }
      .goto-overview {
        @include reset-button;
        width: 480px;
        height: 88px;
        margin-top: 60px;
        margin-left: auto;
        margin-right: auto;
        font-size: 32px;
        color: $white;
        text-align: center;
        line-height: 88px;
        background-color: $darkRed;
        border-radius: 44px;
      }
    }
  }

  .fade-enter-active {
    transition: opacity 0.3s ease-in;
  }
  .fade-leave-active {
    transition: opacity 0.3s ease-out;
  }
  .fade-enter,
  .fade-leave {
    opacity: 0;
  }

  .slide-up-enter-active {
    transition: transform 0.5s ease-out;
  }
  .slide-up-enter {
    transform: translate3d(0, -200%, 0);
  }

  @keyframes progress {
    to {
      stroke-dashoffset: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// DonatePanel.vue?184ff73a